import { BaseApiClient } from '@/services/baseApiClient';
import type {
  GenerateOtpArg,
  IdentifyArg,
  LoginArg,
  LogoutArg,
  MissingRecoveryCodeArg,
  ApproveOAuthConsentArg,
  ResetPasswordArg,
  SetPasswordArg,
  TokenArg,
  VerifyOtpArg,
} from './types/args';
import type {
  GenerateOtpResult,
  IdentifyResult,
  LoginResult,
  LogoutResult,
  MissingRecoveryCodeResult,
  ApproveOAuthConsentResult,
  ResetPasswordResult,
  SetPasswordResult,
  TokenResult,
  VerifyOtpResult,
} from './types/results';

export class AuthApiClient extends BaseApiClient {
  constructor() {
    super('auth');
  }

  public async identify(payload: IdentifyArg): Promise<IdentifyResult> {
    return await this.http.post('v2/identify', payload);
  }

  public login(payload: LoginArg): Promise<LoginResult> {
    return this.http.post('login', payload);
  }

  public logout(payload: LogoutArg): Promise<LogoutResult> {
    return this.http.post('logout', payload);
  }

  public token(payload: TokenArg): Promise<TokenResult> {
    return this.http.post('token', payload);
  }

  public resetPassword(payload: ResetPasswordArg): Promise<ResetPasswordResult> {
    return this.http.post('password/reset', payload);
  }

  public setPassword(payload: SetPasswordArg): Promise<SetPasswordResult> {
    return this.http.post('password/set', payload);
  }

  public generateOtp(payload: GenerateOtpArg): Promise<GenerateOtpResult> {
    return this.http.post('otp/generate', payload);
  }

  public verifyOtp(payload: VerifyOtpArg): Promise<VerifyOtpResult> {
    return this.http.post('otp/verify', payload);
  }

  public missingRecoveryCode(payload: MissingRecoveryCodeArg): Promise<MissingRecoveryCodeResult> {
    return this.http.post('recovery-code/missing', payload);
  }

  public approveOAuthConsent(payload: ApproveOAuthConsentArg): Promise<ApproveOAuthConsentResult | null> {
    return this.http.post('v2/oauth2/consent', {
      accept: true,
      oauth_query: payload.oauthQuery,
    });
  }
}
